import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { subscribe, getState } from '@/store';
import { formatDate } from '@/utils/tool';
import { POLICY_INFO } from '@/constants';

const isDate = date => {
  if (date instanceof Date) {
    return !Number.isNaN(date.getTime());
  }

  return false;
};

const getDate = value => {
  if (!value) {
    return;
  }

  if (typeof value === 'number') {
    return;
  }

  const a = new Date(value);

  if (isDate(a)) {
    return a;
  } // if (typeof value === 'string') {
  //   value = value.replace(/-/g, '/');
  // }
  // const b = new Date(value);
  // if (isDate(b)) {
  //   return b;
  // }

};

const getUnitText = (type = '') => {
  if (!type) {
    return type;
  }

  type = type.toLowerCase();

  if (type === 'y' || type === 'year') {
    return '年';
  }

  if (type === 'm' || type === 'month') {
    return '月';
  }

  if (type === 'd' || type === 'day') {
    return '日';
  }

  if (type === 'season') {
    return '季度';
  }

  return type;
};

const getDesc = (key, value, info = {}, policy = {}) => {
  if (value === undefined) {
    return;
  }

  const date = getDate(value);

  if (['insuranceStartDate', 'insuranceEndDate'].includes(key) && value) {
    return moment(value).format('YYYY-MM-DD HH:mm');
  }

  if (date) {
    const result = formatDate(date, 'yyyy年MM月dd日 hh时mm分ss秒');
    return result;
  }

  if (key === 'insurancePeriod') {
    const {
      insurancePeriodUnitType
    } = policy;

    if (insurancePeriodUnitType === 'life') {
      return '终身';
    }

    const unitText = getUnitText(insurancePeriodUnitType) || '';
    return value ? `${value}${unitText}` : undefined;
  }

  if (key === 'paymentPeriod') {
    const {
      paymentPeriodUnitType
    } = policy;

    if (paymentPeriodUnitType === 'life') {
      return '终身';
    }

    const unitText = getUnitText(paymentPeriodUnitType) || '';
    return value ? `${value}${unitText}` : undefined;
  }

  if (typeof value === 'number') {
    return value < 10000 ? `${value}元` : `${value * 100 / 1000000}万元`;
  }

  return value;
};

const OrderInfo = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    dataSource = []
  } = attrs;
  const cls = classnames({
    'components-order-info-render': true,
    [className]: !!className
  });
  const [policyInfo = {}, setPolicyInfo] = useState({});
  const {
    policyList = []
  } = policyInfo;
  useEffect(() => {
    const fn = () => {
      setPolicyInfo(getState(POLICY_INFO) || {});
    };

    fn();
    subscribe(fn, POLICY_INFO);
  }, []);

  const renderPolicy = (curr = {}) => dataSource.map((item = {}, index) => {
    const {
      label,
      value: key,
      isDefault
    } = item;
    const value = curr[key] || policyInfo[key];
    const desc = getDesc(key, value, policyInfo, curr) || '';

    if (!desc) {
      return null;
    }

    if (!isDefault) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "info-item",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-title"
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "item-desc"
    }, desc));
  });

  const renderPolicyList = () => {
    if (!policyList) {
      return null;
    }

    return policyList.map((policy = {}, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "info-policy",
        key: index
      }, renderPolicy(policy));
    });
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), renderPolicyList());
});
export default OrderInfo;